<template>
  <div v-allow:auth="['batchProcessing.read', 'batchProcessing.create', 'batchProcessing.edit']">
    <sub-header :showBtn="false" :showBreadCrumbs="true" backButton :setEditModeUnlock="setEditModeUnlock" backRedirectionUrl="/batch-processing" />
    <template>
      <div v-if="batchDetailLoading" class="flex w-full justify-center items-center">
          <Loader />
      </div>
      <tabulator-grid v-else :batchDetail="batchDetail"/>
    </template>
  </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import BatchAxios from "../batch-axios";
import TabulatorGrid from "./tabulator-grid.vue";
import Loader from "@shared/loader";
import { checkPermission } from "@shared/utils/functions";



export default {
  name: "BatchProcessingDetails",
  components: {
    SubHeader,
    TabulatorGrid,
    Loader,
  },
  computed: {
    getBatchId() {
      return this.$route.params.id;
    },
    getAction() {
      return this.$route.params.action;
    },
  },
  data() {
    return {
      batchDetail: null,
      batchDetailLoading: false,
      tabularData: false,
    };
  },
  methods: {
    checkPermission,
    async setEditModeLock(batchId, option = null) {
      try {
        let payload = { lock_status: true, batch_id: batchId };
        if (option !== null) {
          payload = { lock_status: false, batch_id: batchId };
        }
        let url = `/batch-processing/locked`;
        await BatchAxios.post(url, payload);
        return true;
      } catch (error) {
        this.$toast.error(
          error.response.data.detail ||
            this.$t("pages.field_table.error_failed_to_lock_this_field")
        );
        return false; // Return false when there's an error
      }
    },

    async setEditModeUnlock() {
        if (this.getAction === 'view') {
            return
        }
        if (checkPermission('batchProcessing.edit') && this.getBatchId) {
            await this.setEditModeLock(this.getBatchId, 'backMode')
        }
    },

    async fetchBatchDetail() {
      try {
        this.batchDetailLoading = true;
        const { data }  = await BatchAxios.get(`/batch-processing/get-batch-processing/${this.getBatchId}`);
        this.batchDetail = data[0];
        this.batchDetailLoading = false;
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.detail || this.$t(`general.default_error`)
        );
        console.error("err in fetchBatchDetail", err);
        this.batchDetailLoading = false;
      }
    },

    handleBeforeUnload() {
      if (this.getAction === 'edit' && this.getBatchId && window.batchTabId) {
        
        const activeTabs = JSON.parse(localStorage.getItem(`batch_tabs_${this.getBatchId}`) || '[]');
        const updatedTabs = activeTabs.filter(id => id !== window.batchTabId);
        
        if (updatedTabs.length === 0) {
          
          localStorage.removeItem(`batch_tabs_${this.getBatchId}`);
          const xhr = new XMLHttpRequest();
          xhr.open('POST', `${BatchAxios.defaults.baseURL}/batch-processing/locked`, false);
          xhr.setRequestHeader('Content-Type', 'application/json');
          if (BatchAxios.defaults.headers.common['Authorization']) {
            xhr.setRequestHeader('Authorization', BatchAxios.defaults.headers.common['Authorization']);
          }
          xhr.send(JSON.stringify({ lock_status: false, batch_id: this.getBatchId }));
        } else {
          
          localStorage.setItem(`batch_tabs_${this.getBatchId}`, JSON.stringify(updatedTabs));
        }
      }
    },

  },
  async mounted() {
    await this.fetchBatchDetail();
    if (this.$route.params.action === "edit") {
    
      if(this.batchDetail.lock && this.batchDetail.locked_by && this.batchDetail.locked_by !== this.$store.getters.getUser?.id) {
        this.$router.push({ path: "/batch-processing" });
        return;
      }

      if (!this.batchDetail.lock) {
        const lockResult = await this.setEditModeLock(this.getBatchId);
        if (lockResult == false) {
          this.$router.push({ path: "/batch-processing" });
        }
      }
    }
    
    if (this.$route.params.action === "edit") {
      const tabId = Date.now() + Math.random();
      const activeTabs = JSON.parse(localStorage.getItem(`batch_tabs_${this.getBatchId}`) || '[]');
      activeTabs.push(tabId);
      localStorage.setItem(`batch_tabs_${this.getBatchId}`, JSON.stringify(activeTabs));
      window.batchTabId = tabId;
    }
    
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  async beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    if (this.getBatchId) {
      await this.setEditModeLock(this.getBatchId, 'backMode');
    }
  },

  async beforeRouteLeave(_to, _from, next) {
    
     if(this.batchDetail.lock) {
        next();
      } else {
        await this.setEditModeUnlock();
        next(); // must call next() to allow navigation
      }
  }
};
</script>

<style lang="scss" scoped></style>
